module.exports = __webpack_public_path__ + "img/146.a20ebcf3.png";